import * as Sentry from "@sentry/react"
import appConfig from "./config";

export const sentryInit = () => {
    Sentry.init({
        dsn: appConfig.sentryDSN,
        normalizeDepth: 10,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration()
        ],
        tracesSampleRate: 1.0,

        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}

